import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Retrieves a preview of the requested {@link ents.core.mosaic.Widget}
     */
    apply: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        cancellation: ({ state }) => ({ ...state, inProgress: false }),
        error: ({ state }) => ({ ...state, inProgress: false }),
        request: ({ state }) => ({ ...state, inProgress: true }),
        success: ({ state }) => ({ ...state, inProgress: false }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
